module.exports = __webpack_public_path__ + "img/Otros.955d8d76.svg";